//@flow
import {
    STRIPE_CARD_DETAILS_INIT,
    STRIPE_CARD_DETAILS_DONE,
    STRIPE_CARD_DETAILS_FAILED
} from "./types";
import { changeCardOrUpgrade } from './changeCardOrUpgrade';
import { showMessage } from "h-commons";

export const stripeSaveCard = (accountUpgrade: Object, cardData: Object, userSession: null | string) => (dispatch) => {
    dispatch({
        type: STRIPE_CARD_DETAILS_INIT
    });
    if (window.Stripe) {
        const Stripe = window.Stripe;
        Stripe.setPublishableKey(accountUpgrade.STRIPE_PUBLISH_KEY);
        Stripe.createToken(cardData, (status, resp) => {
            if (resp.error) {
                showMessage({ message: resp.error.message, type: 'error' });
                dispatch({
                    type: STRIPE_CARD_DETAILS_FAILED
                });
            } else {
                const data = accountUpgrade.stripeId ? {
                    tok: resp.id
                } : {
                        token_id: resp.id,
                        newplan: accountUpgrade.plan.id
                    };
                dispatch(changeCardOrUpgrade(!!accountUpgrade.stripeId, data, userSession));
                dispatch({ type: STRIPE_CARD_DETAILS_DONE });
            }
        });
    } else
        showMessage({ message: 'Failed to save card details. Please refresh the page and try again.', type: 'error' });
}